<template lang="pug">
b-modal#operatorAuditLog(
  ref="operatorAuditLog"
  :title="$t('ui.audit_log')"
  centered
  no-fade
  no-close-on-backdrop
  size="xl"
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    div
      b-form-group(:label="$t('ui.account_id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="account_id"
          required
          type="text"
          :dirty="$v.account_id.$dirty"
          :error="$v.account_id.$error"
          v-model.trim.lazy="$v.account_id.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
      b-form-group.mb-3
        .row
          .col-lg-9.mb-1
            b-pagination.float-left(
              size="sm"
              hide-ellipsis
              :total-rows="totalRow"
              :per-page="getPageSize"
              v-model="currentPage"
              @input="changedPage($event)")
          .col-lg-3.mb-1
            b-input-group(:prepend="$t('ui.page_size')" size="sm")
              b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
          .col-lg-12
            .clusterize-scroll.table-responsive
              table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                thead.thead-light
                  tr
                    th.text-center(width="3%")
                      span #
                    th.text-right(width="7%")
                      span {{ $t('ui.amount') }}
                    th.text-right(width="15%")
                      span {{ $t('ui.balance_before') }}
                    th.text-right(width="15%")
                      span {{ $t('ui.balance_after') }}
                    th(width="20%")
                      span {{ $t('ui.remark') }}
                    th.text-center(width="10%")
                      span {{ $t('ui.type') }}
                    th(width="15%")
                      span {{ $t('ui.action_by') }}
                    th.text-right(width="15%")
                      span {{ $t('ui.action_date') }}
                tbody
                  tr(v-if="logList.length == 0")
                      td(colspan="8").text-center
                        span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in logList")
                    td.text-center
                      span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                    td.text-right
                      span.font-weight-bold(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
                    td.text-right
                      span.font-weight-bold(:title="$n(item.balance_before, 'currency')" :class="$helpers.fontClassName(item.balance_before)") {{ $n(item.balance_before, 'currency') }}
                    td.text-right
                      span.font-weight-bold(:title="$n(item.balance_after, 'currency')" :class="$helpers.fontClassName(item.balance_after)") {{ $n(item.balance_after, 'currency') }}
                    td
                      span(:title="item.remark") {{ item.remark }}
                    td.text-center
                      span(:title="item.action_type") {{ item.action_type }}
                    td
                      span(:title="item.action_by") {{ item.action_by }}
                    td.text-right
                      span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
    //- .row
    //-   .col-12
    //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import BankGroupLookup from "@/library/BankGroupLookup";
import BankAccType from "@/library/BankAccType";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const greaterThanZero = (value) => value > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    BankAccType,
    BankGroupLookup
  },
  props: { 
    item: {
      type: Object
    },
  },
  data() {
    return {
      account_id: null,
      logList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      currentPage: 1,
      totalRow: 0,
      sortKey: "",
      sortType: "asc",
    };
  },
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    // operatorID() {
    //   return this.$store.getters.selectedOperatorID;
    // },
  },
  validations: {
    account_id: {
      required,
      alphaNum,
      minLength: minLength(6),
      maxLength: maxLength(20)
    }
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.operatorAuditLog(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    operatorAuditLog: function(isSearch) {
      let url = config.operatorWalletLogUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.account_id,
        // sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.logList = response.data.dt;
                this.totalRow = this.logList.length > 0 ? this.logList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.operatorAuditLog(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.operatorAuditLog();
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.logList = [];
      this.account_id = this.item.account_id;
      this.operatorAuditLog();
    }
  }
};
</script>
  